import { Switch, Field, Label } from "@headlessui/react";
import { XIcon, CheckIcon } from "@phosphor-icons/react";
import clsx from "clsx";

export default function ToggleSwitch({
	enabled,
	setEnabled,
	label,
	displayLabel = true,
}: {
	enabled: boolean;
	setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
	label: string;
	displayLabel?: boolean;
}) {
	return (
		<Field className="jF-flex jF-items-center jF-justify-between jF-gap-2">
			{displayLabel && (
				<Label as="span" className="jF-text-sm hover:jF-cursor-pointer">
					{label.length > 0 ? (
						<span className="jF-font-medium jF-text-gray-900">{label}</span>
					) : (
						<span className="jF-text-[0.9rem] jF-text-gray-500">
							I consent to my information being shared with BiiGGA and agree to the{" "}
							<a
								className="jF-text-[--jF-theme-color] jF-font-semibold"
								href="/privacy-policy"
								target="_blank"
							>
								terms & conditions
							</a>
							.
						</span>
					)}
				</Label>
			)}
			<Switch
				checked={enabled}
				onChange={setEnabled}
				className={clsx(
					enabled ? "" : "jF-bg-gray-200",
					`jF-relative jF-inline-flex jF-h-6 jF-w-11 jF-flex-shrink-0 jF-cursor-pointer jF-rounded-full jF-border-2 jF-border-[--jF-theme-color] jF-transition-colors jF-duration-200 jF-ease-in-out focus:jF-outline-none focus:jF-ring-2 focus:jF-ring-offset-2`,
				)}
				style={
					{
						backgroundColor: enabled ? "var(--jF-theme-color)" : "",
						"--tw-ring-color": "var(--jF-theme-color)",
					} as React.CSSProperties
				}
			>
				<span className="jF-sr-only">I agree to the terms and conditions</span>
				<span
					className={clsx(
						enabled ? "jF-translate-x-5" : "jF-translate-x-0",
						"jF-pointer-events-none jF-relative jF-inline-block jF-h-5 jF-w-5 jF-transform jF-rounded-full jF-bg-white jF-shadow jF-ring-0 jF-transition jF-duration-200 jF-ease-in-out",
					)}
				>
					<span
						className={clsx(
							enabled
								? "jF-opacity-0 jF-duration-100 jF-ease-out"
								: "jF-opacity-100 jF-duration-200 jF-ease-in",
							"jF-absolute jF-inset-0 jF-flex jF-h-full jF-w-full jF-items-center jF-justify-center jF-transition-opacity",
						)}
						aria-hidden="true"
					>
						<XIcon
							className="jF-h-3 jF-w-3 jF-stroke-[--jF-theme-color] jF-stroke-[10%]"
							size={32}
						/>
					</span>
					<span
						className={clsx(
							enabled
								? "jF-opacity-100 jF-duration-200 jF-ease-in"
								: "jF-opacity-0 jF-duration-100 jF-ease-out",
							"jF-absolute jF-inset-0 jF-flex jF-h-full jF-w-full jF-items-center jF-justify-center jF-transition-opacity",
						)}
						aria-hidden="true"
					>
						<CheckIcon
							className="jF-h-3 jF-w-3 jF-stroke-[--jF-theme-color] jF-stroke-[10%]"
							size={32}
						/>
					</span>
				</span>
			</Switch>
		</Field>
	);
}
